module.exports = __webpack_public_path__ + "img/invitation-sent.94fb73db.webp";